<template>
    <div>
        <v-card>
            <v-card-text>
                <div>
                    <v-row>
                        <v-col cols="1">
                            <div class="not-gold-msg">
                                <v-icon>mdi-alert-circle</v-icon>
                            </div>
                        </v-col>
                        <v-col cols="11">
                            <div>
                                <div>Sorry!</div>
                                <div>
                                    This feature is only available for
                                    <strong>Premium Users.</strong>
                                </div>
                                <div>
                                    Please contact us at
                                    <a class="italics-styling"
                                        href="mailto: hello@eduracle.com"
                                    >'hello@eduracle.com'</a>
                                    to upgrade to
                                    <strong>Premium.</strong>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    name: "VerifyMobile",
    props: ["onClose", "status", "data"],
    computed: {
        ...mapState("userStore", ["user"])
    },
    methods: {
        verifyMobile() {
            let telegramLink = this.getTelegramLink(this.user);
            window.open(telegramLink, "_blank");
            this.onClose({ status: false });
        }
    }
};
</script>

